(function (upp, angular) {
    'use strict';

    AccountFieldsController.$inject = [ '$scope', 'customerAccountService' ];
    function AccountFieldsController($scope, customerAccountService) {
        Object.defineProperties(this, {
            email: { value: '', writable: true },
            name: { value: '', writable: true },
            password: { value: null, writable: true },
            surname: { value: '', writable: true },
            fields: { value: [], writable: true },
            fieldValues: { value: [], writable: true },
            changePassword: { value: false, writable: true },
            onChange: {
                enumerable: true,
                get: function() { return $scope.onChange || angular.noop },
            },
        });

        var accountSub = customerAccountService.accountInfo$
            .filter(function(data) { return !!data })
            .subscribe(function(data) {
                Object.assign(this, {
                    email: data.email,
                    name: data.name,
                    surname: data.surname,
                    fieldValues: data.fields,
                });
                $scope.$evalAsync();
            }.bind(this));

        var fieldsSub = customerAccountService.fields$
            .subscribe(function(fields) {
                this.fields = fields;
                $scope.$evalAsync();
            }.bind(this));

        $scope.$on('$destroy', function() {
            accountSub.unsubscribe();
            fieldsSub.unsubscribe();
        });
    }

    AccountFieldsController.prototype.onCustomerFieldsChange = function(fields) {
        Object.assign(this, {
            fieldValues: fields,
        });
        this.notifyChanges();
    }

    AccountFieldsController.prototype.onPasswordChange = function(password) {
        Object.assign(this, {
            password: password,
        });
        this.notifyChanges();
    }

    AccountFieldsController.prototype.toggleChangePassword = function() {
        this.changePassword = !this.changePassword;
        if (!this.changePassword)
            this.password = null;
        this.notifyChanges();
    }

    AccountFieldsController.prototype.notifyChanges = function() {
        this.onChange({
            $event: {
                email: this.email,
                password: this.password,
                name: this.name,
                surname: this.surname,
                fields: this.fieldValues,
            }
        });
    }

    upp.directive('accountFields', [ function () {
        return {
            restrict: 'E',
            scope: {
                onChange: '&?',
            },
            templateUrl: require('../templates/account-fields.html'),
            controllerAs: '$ctrl',
            controller: AccountFieldsController,
        };
    } ]);

}(upp, angular));



// WEBPACK FOOTER //
// ./src/app/modules/customer-account/component/account-fields.component.js